'use client'

import { useEffect } from 'react'
import { useEventEmitterContext } from '@/lib/contexts/EventEmitterContext'
import { useRouter } from 'nextjs-toploader/app'
import debounce from 'lodash/debounce'

/**
 * This component is responsible for setting up the search callback for external apps.
 */
export default function SetupSearchCallback({ debounceWait = 250 }: { debounceWait?: number } = {}) {
  const router = useRouter()
  const appEvent$ = useEventEmitterContext()

  useEffect(() => {
    // Check if the window object is available (i.e., we're in the browser)
    if (typeof window === 'undefined') {
      return
    }

    console.debug('Setting up search callback')
    window.pcSearchCallback = debounce((query?: string, mainCategory?: string) => {
      console.debug('pcSearchCallback called, triggering search:callback event', { query, mainCategory })
      appEvent$.emit({
        type: 'search:callback',
        payload: {
          query: query ?? '',
          mainCategory: mainCategory ?? 'all',
        },
      })
    }, debounceWait)

    // Cleanup function to remove the callback when the component unmounts
    return () => {
      console.debug('Cleaning up search callback')
      window.pcSearchCallback = undefined
    }
  }, [appEvent$, debounceWait, router])

  return null
}
